// Moves a routine step's flip cards (ingredients, Olive's tip) into the product row that
// follows it and shows just enough of them to fill out the last row of products.
(function () {
  if (window.naturallFlipTiles) return;
  window.naturallFlipTiles = true;
  function columnsOf(grid) {
    var first = null;
    for (var i = 0; i < grid.children.length; i++) {
      var el = grid.children[i];
      if (!el.hidden && el.offsetWidth > 0) { first = el; break; }
    }
    if (!first) return 1;
    return Math.max(1, Math.round(grid.clientWidth / first.getBoundingClientRect().width));
  }

  function layout(grid, tiles) {
    tiles.forEach(function (t) { t.hidden = false; });
    // Blank filler spots don't count as products: the flip cards take those spots instead.
    var fillers = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__filler'));
    grid.setAttribute('data-flip-fill', '');
    fillers.forEach(function (f) { f.classList.remove('is-on'); });
    var products = 0;
    for (var i = 0; i < grid.children.length; i++) {
      var child = grid.children[i];
      if (tiles.indexOf(child) === -1 && fillers.indexOf(child) === -1) products++;
    }
    var cols = columnsOf(grid);
    var pool = tiles.length;
    var show;
    if (cols === 1) {
      show = Math.min(pool, 4);
    } else {
      var gaps = (cols - (products % cols)) % cols;
      show = gaps + cols <= pool ? gaps + cols : gaps;
      if (show === 0) show = Math.min(pool, cols);
    }
    tiles.forEach(function (t, i) { t.hidden = i >= show; });
    // If there aren't enough flip cards to finish the last row, use blank tiles for what's left.
    if (cols > 1) {
      var left = (cols - ((products + show) % cols)) % cols;
      fillers.forEach(function (f, i) { if (i < left) f.classList.add('is-on'); });
    }
    return cols;
  }

  function setup(source) {
    if (source.dataset.flipReady) return;
    source.dataset.flipReady = 'true';
    var section = source.closest('.shopify-section');
    var next = section && section.nextElementSibling;
    var grid = next && next.querySelector('.product-grid');
    var tiles = Array.prototype.slice.call(source.children);
    if (!grid || tiles.length === 0) {
      source.hidden = false;
      source.classList.add('flip-tiles-source--standalone');
      return;
    }
    var slideClass = grid.querySelector('.slider__slide') ? 'slider__slide' : null;
    tiles.forEach(function (t) {
      if (slideClass) t.classList.add(slideClass);
      grid.appendChild(t);
    });
    var cols = layout(grid, tiles);
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (columnsOf(grid) !== cols) cols = layout(grid, tiles);
      }, 150);
    });
  }

  function flip(button) {
    var flipped = button.classList.toggle('is-flipped');
    button.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    var front = button.querySelector('.flip-tile__face--front');
    var back = button.querySelector('.flip-tile__face--back');
    if (front) front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
    if (back) back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.flip-tile');
    if (button) flip(button);
  });

  function init() {
    document.querySelectorAll('[data-flip-tiles-for]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
